import type { FC } from 'react';
import React from 'react';
import Modal from 'react-responsive-modal';

interface Props {
  isMobile: boolean;
  isOpen: boolean;
  children: React.ReactNode;
}

const Styles = {
  position: 'relative',
  flexDirection: 'column',
  display: 'flex',
  width: '100vw',
  height: '100vh',
  margin: 0,
  padding: 0,
  zIndex: 9999,
} as const;

export const Container: FC<Props> = ({ isMobile, isOpen, children }) =>
  isMobile ? (
    <>
      {/** TODO: @see https://tracker.yandex.ru/LT-39577 */}
      {/** @ts-ignore */}
      <Modal
        styles={{
          modal: Styles,
          overlay: { padding: 0, zIndex: 0 },
        }}
        open={isOpen}
      >
        {children}
      </Modal>
    </>
  ) : (
    <>{children}</>
  );
